/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

( function( app ) {
  const COMPONENT = {

    loadPopup: function( popupId ) {
      $.magnificPopup.open( {
        items: {
          src: popupId,
        },
        type: 'inline',
        fixedContentPos: true,
        fixedBgPos: true,
        overflowY: 'auto',
        closeBtnInside: true,
        preloader: false,
        midClick: true,
        removalDelay: 300,
      }, 0 );
    },

    initAgeGate: function() {
      const ageGate = document.getElementById( 'age-gate' );
      if ( ! ageGate ) {
        return;
      }

      if ( ! localStorage.getItem( 'age_verified' ) ) {
        ageGate.classList.add( 'is-active' );
        document.body.style.overflow = 'hidden';
      }

      const form = document.getElementById( 'age-gate-form' );
      const errorEl = document.getElementById( 'age-gate-error' );
      const selects = form ? form.querySelectorAll( 'select' ) : [];

      if ( ! form ) {
        return;
      }

      form.querySelectorAll( 'input[name="location"]' ).forEach( ( radio ) => {
        radio.addEventListener( 'change', () => {
          document.getElementById( 'age-gate-location' ).classList.remove( 'is-invalid' );
        } );
      } );

      form.addEventListener( 'submit', function( e ) {
        e.preventDefault();

        const locationField = document.getElementById( 'age-gate-location' );
        const location = form.querySelector( 'input[name="location"]:checked' );
        const month = parseInt( document.getElementById( 'age-gate-month' ).value );
        const day = parseInt( document.getElementById( 'age-gate-day' ).value );
        const year = parseInt( document.getElementById( 'age-gate-year' ).value );

        selects.forEach( ( s ) => s.classList.remove( 'is-invalid' ) );
        locationField.classList.remove( 'is-invalid' );
        errorEl.hidden = true;

        if ( ! location || ! month || ! day || ! year ) {
          selects.forEach( ( s ) => {
            if ( ! s.value ) {
              s.classList.add( 'is-invalid' );
            }
          } );
          if ( ! location ) {
            locationField.classList.add( 'is-invalid' );
          }
          errorEl.textContent = ! location ?
            'Please select your location and enter your full date of birth.' :
            'Please enter your full date of birth.';
          errorEl.hidden = false;
          return;
        }

        // US visitors must be 21+, Aruba and other countries 18+.
        const minAge = parseInt( location.dataset.minAge ) || 21;

        const today = new Date();
        const birthDate = new Date( year, month - 1, day );
        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDiff = today.getMonth() - birthDate.getMonth();
        if ( monthDiff < 0 || ( monthDiff === 0 && today.getDate() < birthDate.getDate() ) ) {
          age--;
        }

        if ( age >= minAge ) {
          localStorage.setItem( 'age_verified', '1' );
          ageGate.classList.remove( 'is-active' );
          document.body.style.overflow = '';
        } else {
          errorEl.textContent = 'You must be ' + minAge + ' or older to enter this site.';
          errorEl.hidden = false;
        }
      } );
    },

    init: function() {
      const _this = this;

      _this.initAgeGate();

      $( document ).on( 'click', '.js-init-popup', function( e ) {
        e.preventDefault();
        const popupId = $( this ).data( 'modal' );

        if ( popupId !== '' ) {
          _this.loadPopup( popupId );
        }
      } );
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'modal', COMPONENT );
} )( app );
